import { render } from "./HeroiconsSolidAdjustments.vue?vue&type=template&id=204b2d21"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAdjustments.vue"]])

export default __exports__